import request from '@/utils/request'

export function download (params) {
  return request.get('/download', {
    params,
    responseType: 'blob'
  })
}
